import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Utilities
import VideoUpload from 'components/VideoUpload';

type Props = {
  // Left empty by default — the regular quiz form wraps this in an Accordion
  // whose own header already carries the label, so a second one would be
  // redundant. Callers that render it without that Accordion (e.g. the agent
  // dialog) can pass one explicitly.
  label?: string;
  // Default bleeds -mx-6/px-6 to align with the Accordion content it's
  // normally nested in. Callers rendering this as a flex column (e.g. the
  // agent's Branding row) should override it — the bleed pushes the box
  // wider than its column, which was knocking it onto its own line.
  className?: string;
}

const PromoVideoForm:FC<Props> = ({ label = '', className = 'w-full flex flex-wrap -mx-6 -y-4 px-6 pb-3' }) => {
  const { control } = useFormContext();

  return (
    <div className={className}>
      <div className="w-full px-6">
        <Controller
          control={control} name="promoVideo"
          render={({ field }) => (
            <VideoUpload
              {...field}
              label={label}
              helperText="pages.quizForm.promoVideoHint"
            />
          )}
        />
      </div>
    </div>
  )
}

export default PromoVideoForm;
